var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0577 3.61746C11.2939 3.67677 11.4121 3.97328 11.2349 4.15119L9.04979 6.46399L9.46318 9.60703C9.52224 9.84424 9.22696 10.0815 8.99073 9.96285L6.0379 8.59889L3.08507 9.96285C2.84884 10.0815 2.61262 9.90355 2.61262 9.60703L3.02601 6.46399L0.959033 4.15119C0.781863 3.97328 0.84092 3.67677 1.1362 3.61746L4.2662 3.02444L5.80167 0.177908C5.91979 -0.0593027 6.27413 -0.0593027 6.39224 0.177908L7.92771 3.02444L11.0577 3.61746Z",
    fill: "#DCDCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarEmpty);
export default __webpack_public_path__ + "static/media/rating_star_empty.ca976604c76b6de6b391f01d8b1eee02.svg";
export { ForwardRef as ReactComponent };